import { inject, Injectable, signal, TemplateRef } from '@angular/core';
import { ThemeService } from './theme.service';

@Injectable({ providedIn: 'root' })
export class SidenavService {
    private readonly themeService = inject(ThemeService);
    /** Right Sidenav */
    private readonly _rightContent = signal<TemplateRef<any> | null>(null);
    private readonly _rightOpen = signal<boolean>(false);
    readonly rightContent = this._rightContent.asReadonly();
    readonly rightOpen = this._rightOpen.asReadonly();

    /** Left Sidenav */
    private readonly _leftContent = signal<TemplateRef<any> | null>(null);
    private readonly _leftOpen = signal<boolean>(false);
    readonly leftContent = this._leftContent.asReadonly();
    readonly leftOpen = this._leftOpen.asReadonly();

    /** Bottom Sidenav */
    private readonly _bottomContent = signal<TemplateRef<any> | null>(null);
    private readonly _bottomOpen = signal<boolean>(false);
    readonly bottomContent = this._bottomContent.asReadonly();
    readonly bottomOpen = this._bottomOpen.asReadonly();

    /** Mobile Action Bar Visibility */
    readonly mobileActionsVisible = signal<boolean>(false);


    setRightContent(template: TemplateRef<any> | null) {
        this._rightContent.set(template);
        if (!template) this._rightOpen.set(false);
    }

    setLeftContent(template: TemplateRef<any> | null) {
        this._leftContent.set(template);
        if (!template) this._leftOpen.set(false);
    }

    setBottomContent(template: TemplateRef<any> | null) {
        this._bottomContent.set(template);
        if (!template) this._bottomOpen.set(false);
    }

    setRightOpen(open: boolean) { this._rightOpen.set(open); }
    setLeftOpen(open: boolean) { this._leftOpen.set(open); }
    setBottomOpen(open: boolean) { this._bottomOpen.set(open); }

    /**
     * Opens the right sidenav only if the condition is met AND we are not on mobile.
     * This is used for automatic opening of panels.
     */
    setRightOpenSmart(condition: boolean) {
        if (this.themeService.isMobile()) {
            this._rightOpen.set(false);
            return;
        }
        this._rightOpen.set(condition);
    }


    toggleRight() { this._rightOpen.update(v => !v); }
    toggleLeft() { this._leftOpen.update(v => !v); }
    toggleBottom() { this._bottomOpen.update(v => !v); }

    closeAll() {
        this._rightOpen.set(false);
        this._leftOpen.set(false);
        this._bottomOpen.set(false);
    }
}
